import { render } from "./UsefulTips.vue?vue&type=template&id=3cb91231&scoped=true"
import script from "./UsefulTips.vue?vue&type=script&lang=js"
export * from "./UsefulTips.vue?vue&type=script&lang=js"

import "./UsefulTips.vue?vue&type=style&index=0&id=3cb91231&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb91231"]])

export default __exports__